import { useState, useRef, useEffect } from "react";

export const cleanFilteredList = (list) => {
  return Array.from(
    new Set(
      list
        .map((item) => {
          if (item != false && item != null && item != undefined) {
            return item.toLowerCase();
          }
        })
        .filter(Boolean)
    )
    ).sort((a, b) => a.localeCompare(b));
};

const SearchInput = ({
  placeholder,
  placeholderKey,
  input,
  setLiveTextIndex,
  setPlaceholdersValues,
  keywordsList,
  setDisplayTriggerInput,
}) => {
  const [inputValue, setInputValue] = useState("");
  const [focusedIndex, setFocusedIndex] = useState(-1);
  const [filteredList, setFilteredList] = useState(
    keywordsList && cleanFilteredList(keywordsList)
  );
  const [activateInput, setActivateInput] = useState(false);
  const inputRef = useRef();
  const listRef = useRef();

  // ---> 2. ADD THIS NEW USEEFFECT BLOCK <---
  // This watches for the delayed backend response and updates the dropdown dynamically
  useEffect(() => {
    if (keywordsList) {
      // If the user already typed something, re-filter the new list based on their input
      if (inputValue) {
        const filtered = keywordsList.filter((item) =>
          item ? item.toLowerCase().includes(inputValue.toLowerCase()) : null
        );
        setFilteredList(cleanFilteredList(filtered));
      } else {
        // Otherwise, just show the newly updated cascading list
        setFilteredList(cleanFilteredList(keywordsList));
      }
    }
  }, [keywordsList]); 
  // -----------------------------------------

  function adjustScroll(index) {
    const dropdown = listRef.current;
    // SAFETY CHECK: If the dropdown isn't rendered, do nothing to prevent the crash!
    if (!dropdown) return; 

    const itemHeight = 40; // tab height/ number of visible items
    const scrollTop = dropdown.scrollTop;
    const scrollBottom = scrollTop + dropdown.clientHeight;
    const itemTop = index * itemHeight;
    const itemBottom = itemTop + itemHeight;
    if (itemBottom > scrollBottom) {
      dropdown.scrollTop += itemBottom - scrollBottom; // Scroll down
    } else if (itemTop < scrollTop) {
      dropdown.scrollTop -= scrollTop - itemTop; // Scroll up
    }
  }

  function handleKeyboardEvents(e) {
    if (e.key === "Enter") {
      if (inputValue === "") {
        setPlaceholdersValues(placeholderKey, "any");
      } else {
        setPlaceholdersValues(placeholderKey, inputValue);
      }
      setLiveTextIndex();
      setLiveTextIndex("next");
      setActivateInput(false);
    } else if (e.key === "ArrowDown") {
      // SAFETY CHECK: Stop if list is empty
      if (!filteredList || filteredList.length === 0) return; 
      
      setFocusedIndex((prev) => {
        const nextIndex = prev === filteredList.length - 1 ? 0 : prev + 1;
        adjustScroll(nextIndex);
        return nextIndex;
      });
      setInputValue(
        filteredList[
          focusedIndex === filteredList.length - 1 ? 0 : focusedIndex + 1
        ]
      );
    } else if (e.key === "ArrowUp") {
      // SAFETY CHECK: Stop if list is empty
      if (!filteredList || filteredList.length === 0) return;

      setFocusedIndex((prev) => {
        const nextIndex = prev <= 0 ? filteredList.length - 1 : prev - 1;
        adjustScroll(nextIndex);
        return nextIndex;
      });
      setInputValue(
        filteredList[
          focusedIndex === 0 ? filteredList.length - 1 : focusedIndex - 1
        ]
      );
    }
  }
  
  function handleInputChange(value) {
    setInputValue(value);
    const filtered = keywordsList.filter((item) =>
      item ? item.toLowerCase().includes(value.toLowerCase()) : null
    );

    const uniqueFiltered = cleanFilteredList(filtered);

    setFilteredList(uniqueFiltered);
    setFocusedIndex(-1);
  }
  function handleListItemClick(item) {
    setInputValue(item);
    setFocusedIndex(filteredList.indexOf(item));
    inputRef.current.focus();
  }

  function textInputClick() {
    setDisplayTriggerInput(false);
    setActivateInput(true);
  }

  return (
    <>
      {input || activateInput ? (
        <div className="dss-input-wrapper">
          <input
            type="text"
            className={
              "dss-keywords-input " + (!!inputValue.length ? "" : "empty")
            }
            autoFocus
            placeholder={placeholder}
            onChange={(e) => handleInputChange(e.target.value)}
            onKeyDown={handleKeyboardEvents}
            value={inputValue}
            ref={inputRef}
          />
          {!!filteredList.length && (
            <div className="dss-input-dropdown-list" ref={listRef}>
              {filteredList.map((item, index) => (
                <div
                  key={index}
                  className={
                    "dss-input-dropdown-item " +
                    (index === focusedIndex ? "hovered" : "")
                  }
                  onClick={() => handleListItemClick(item)}
                >
                  {index + 1 + ". " + item}
                </div>
              ))}
            </div>
          )}
        </div>
      ) : (
        <div className="search-keyword" onClick={() => textInputClick()}>
          {placeholder}
        </div>
      )}
    </>
  );
};

export default SearchInput;
